import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import '../styles/ExportsPage.css';

const geoUrl = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

const highlightCountries = {
  Germany: { key: 'germany', label: 'Almanya' },
  France: { key: 'france', label: 'Fransa' },
  Italy: { key: 'italy', label: 'İtalya' },
  Spain: { key: 'spain', label: 'İspanya' },
  Netherlands: { key: 'netherlands', label: 'Hollanda' },
  Belgium: { key: 'belgium', label: 'Belçika' },
  'United Kingdom': { key: 'united_kingdom', label: 'İngiltere' },
  'United States of America': { key: 'united_states', label: 'ABD' },
  Russia: { key: 'russia', label: 'Rusya' },
  Azerbaijan: { key: 'azerbaijan', label: 'Azerbaycan' },
  Georgia: { key: 'georgia', label: 'Gürcistan' },
  Iraq: { key: 'iraq', label: 'Irak' },
  Qatar: { key: 'qatar', label: 'Katar' },
  'Saudi Arabia': { key: 'saudi_arabia', label: 'Suudi Arabistan' },
  'United Arab Emirates': { key: 'united_arab_emirates', label: 'BAE' },
  Romania: { key: 'romania', label: 'Romanya' },
  Bulgaria: { key: 'bulgaria', label: 'Bulgaristan' }
};

const WorldMap = ({ activeCountry }) => {
  return (
    <div className="world-map-container" style={{ width: '100%', height: 'auto', minHeight: '500px', position: 'relative' }}>
      <ComposableMap projection="geoMercator" projectionConfig={{ scale: 150, center: [20, 10] }}>
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const countryName = geo.properties.name;
              const country = highlightCountries[countryName];
              const isHighlighted = Boolean(country);
              const isActive = isHighlighted && activeCountry === country.key;

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={isHighlighted ? country.label : ''}
                  className={isActive ? 'map-country-active' : ''}
                  style={{
                    default: {
                      fill: isActive ? 'var(--secondary-color)' : isHighlighted ? 'rgba(212, 175, 55, 0.72)' : '#D6D6DA',
                      stroke: isActive ? '#ffffff' : '#FFFFFF',
                      strokeWidth: isActive ? 1.4 : 0.5,
                      outline: 'none',
                      transition: 'fill 0.25s ease, stroke-width 0.25s ease'
                    },
                    hover: {
                      fill: isHighlighted ? 'var(--secondary-color)' : '#D6D6DA',
                      stroke: '#FFFFFF',
                      strokeWidth: isHighlighted ? 1.4 : 0.5,
                      outline: 'none',
                      cursor: isHighlighted ? 'pointer' : 'default'
                    },
                    pressed: {
                      fill: isHighlighted ? 'var(--secondary-color)' : '#D6D6DA',
                      outline: 'none'
                    }
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
      <Tooltip
        id="my-tooltip"
        float={true}
        style={{
          backgroundColor: 'rgba(0,0,0,0.8)',
          color: '#fff',
          borderRadius: '8px',
          fontSize: '0.9rem',
          zIndex: 1000
        }}
      />
    </div>
  );
};

export default WorldMap;
